///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="processEditor-module.ts"/>
module ProcessEditor {
    "use strict";

    export class GraphValidationService {
        public drawingServiceInstances: ConnectionDrawingService[];

        static $inject = ["$rootScope", "$templateCache", "$timeout", "ProcessService", "RecursiveNodeCollector"];
        constructor(private $rootScope, private $templateCache: ng.ITemplateCacheService, private $timeout: ng.ITimeoutService, private processService: ProcessService, private recursiveNodeCollector) {
            this.drawingServiceInstances = [];
        }

        // Called when the process editor save button is clicked. Run all validations.
        public validateGraph() {
            var errors = [];

            var allNodesConnected = this.checkAllNodesConnected();
            if (!allNodesConnected) {
                errors.push(FRENDS.Localizations.Validation_AllNodesMustBeConnected);
            }

            var allPathsReturn = this.checkAllPathsReturn();
            if (!allPathsReturn) {
                errors.push(FRENDS.Localizations.Validation_AllPathsMustReturn);
            }

            var decisionNodes = this.checkDecisionNodeElseBranches();
            if (decisionNodes.missingElse) {
                errors.push(FRENDS.Localizations.Validation_ElseBranchRequired);
            }
            if (decisionNodes.multipleElse) {
                errors.push(FRENDS.Localizations.Validation_TooManyElseBranches);
            }

            var invalidExpressions = this.checkForInvalidConditionExpressions();
            if (invalidExpressions) {
                errors.push(FRENDS.Localizations.Validation_ConditionExpressionsRequired);
            }

            return {
                success: errors.length === 0,
                errorMessage: this.buildValidationErrorMessage(errors)
            };
        }

        // ConnectionDrawingService calls this directly when connections are created or detached
        public validateGraphConnections() {
            this.checkAllNodesConnected();
            this.checkAllPathsReturn();
        }

        // scopeEditorController calls this directly when the else branch switch is toggled, or when an else branch is removed.
        public checkDecisionNodeElseBranches() {
            var missingElse = false;
            var multipleElse = false;

            var decisionNodes = this.recursiveNodeCollector.getDecisions(this.processService.currentProcess.rootScope);
            _.each(decisionNodes,(decisionNode: DecisionNode) => {
                var elseBranches = _.filter(decisionNode.conditionBranches, c => c.isElseBranch);
                var nodeElement = $("#" + decisionNode.nodeId).find(".decision-diamond");
                if (elseBranches.length === 0) {
                    missingElse = true;
                    nodeElement.addClass("process-node-invalid").attr("title", FRENDS.Localizations.Validation_ElseBranchRequired);
                } else if (elseBranches.length > 1) {
                    multipleElse = true;
                    nodeElement.addClass("process-node-invalid").attr("title", FRENDS.Localizations.Validation_TooManyElseBranches);
                } else {
                    nodeElement.removeClass("process-node-invalid").attr("title", "");
                }
            });

            return {
                missingElse: missingElse,
                multipleElse: multipleElse
            };
        }

        public markProcessDirty() {
            // Timeout to initiate digest loop. Sometimes it's called from outside of digest loop (jsplumb),
            // while other times it's called from within a d-loop. So manual $rootscope.$apply will crash.
            this.$timeout(() => {
                this.$rootScope.$broadcast("process.dirty.frends");
            });
        }

        private checkForInvalidConditionExpressions() {
            // Update the UI to show red borders around invalid condition labels (and mark the form as dirty)
            this.$rootScope.$broadcast("validateConditionExpressions");

            var decisionNodes = this.recursiveNodeCollector.getDecisions(this.processService.currentProcess.rootScope);
            var conditions = _.chain(decisionNodes).map((d:DecisionNode) => d.conditionBranches).flatten().value();
            return _.some<any>(conditions, c => !c.isElseBranch && !c.expression);
        }

        // Go though all drawingServiceInstances (scope nodes), and check that all target endpoints have a connection.
        private checkAllNodesConnected() {
            var floaters = [];
            _.each(this.drawingServiceInstances,(connectionDrawingService: ConnectionDrawingService) => {
                var floatersInScope = this.getTargetsWithNoSource(connectionDrawingService.jsPlumbObj);
                floaters = floaters.concat(floatersInScope);
            });
            return floaters.length === 0;
        }

        // Go though all drawingServiceInstances (scope nodes), and check that all source endpoints have a connection.
        private checkAllPathsReturn() {
            var stragglers = [];
            _.each(this.drawingServiceInstances,(connectionDrawingService: ConnectionDrawingService) => {
                var stragglersInScope = this.getSourcesWithNoTargets(connectionDrawingService.jsPlumbObj);
                stragglers = stragglers.concat(stragglersInScope);
            });
            return stragglers.length === 0;
        }

        private getTargetsWithNoSource(jsPlumbObj) {
            var floaters = [];
            jsPlumbObj.selectEndpoints().each((ep) => {
                if (ep.isTarget) {
                    var endpointElement = angular.element(ep.canvas);
                    if (ep.connections.length < 1) {
                        floaters.push(ep.elementId);
                        endpointElement.addClass("invalid-endpoint").attr("title", FRENDS.Localizations.Validation_AllNodesMustBeConnected);
                    } else {
                        endpointElement.removeClass("invalid-endpoint").attr("title", "");
                    }
                }
            });
            return floaters;
        }

        private getSourcesWithNoTargets(jsPlumbObj) {
            var stragglers = [];
            jsPlumbObj.selectEndpoints().each((ep) => {
                if (ep.isSource && ep.getParameters().type !== "failBranch") {
                    var endpointElement = angular.element(ep.canvas);
                    if (ep.connections.length < 1) {
                        stragglers.push(ep.elementId);
                        endpointElement.addClass("invalid-endpoint").attr("title", FRENDS.Localizations.Validation_AllPathsMustReturn);
                    } else {
                        endpointElement.removeClass("invalid-endpoint").attr("title", "");
                    }
                }
            });
            return stragglers;
        }

        private buildValidationErrorMessage(errors) {
            var message = $(this.$templateCache.get("graphValidationError.htm"));
            var ul = message.find(".errors-list");

            _.each(errors,(errorText) => {
                var li = $("<li>" + errorText + "</li>");
                ul.append(li);
            });

            return message.prop("outerHTML"); // notifications.error expects the message to be a string
        }
    }

    app.service("GraphValidationService", GraphValidationService);
}